// Ngăn Pull-to-Refresh nhưng vẫn cho phép scroll trong các phần tử con
document.addEventListener("touchmove", function(event) {
    let target = event.target;

    while (target !== document.body && target !== document.documentElement) {
        if (target.scrollHeight > target.clientHeight) {
            return; // Cho phép cuộn trong phần tử có thể scroll
        }
        target = target.parentNode;
    }

    // Ngăn cuộn trang nếu không phải trong phần tử có thể scroll
    if (window.scrollY === 0) {
        //event.preventDefault();
        event.stopPropagation();
    }
}, { passive: false });

// Ngăn chuyển trang khi vuốt ngang
document.addEventListener("touchstart", function(event) {
    if (event.touches.length > 1) {
        event.preventDefault();
    }
}, { passive: false });

document.addEventListener("gesturestart", function(event) {
    event.preventDefault();
});

// Hiển thị cảnh báo khi đóng tab hoặc reload
window.addEventListener("beforeunload", function(event) {
    event.preventDefault();
    event.returnValue = "";
});

// Ngăn nhấn nút Back để thoát khỏi trang
history.pushState(null, "", location.href);
window.addEventListener("popstate", function(event) {
    history.pushState(null, "", location.href);
});

// Áp dụng overscroll-behavior
document.addEventListener("DOMContentLoaded", function() {
    document.documentElement.style.overscrollBehaviorY = "contain";
    document.documentElement.style.height = "100%";
    document.documentElement.style.overflow = "hidden";

    document.body.style.overscrollBehaviorY = "contain";
    document.body.style.height = "100%";
    document.body.style.overflow = "hidden";
});

// Ngăn zoom khi nhập input trên mobile
document.addEventListener("focusin", function(event) {
    if (event.target.tagName === "INPUT" || event.target.tagName === "TEXTAREA") {
        document.documentElement.style.overscrollBehaviorY = "none";
        document.body.style.overscrollBehaviorY = "none";
    }
});

document.addEventListener("focusout", function() {
    document.documentElement.style.overscrollBehaviorY = "contain";
    document.body.style.overscrollBehaviorY = "contain";
});

// Giữ trang không bị di chuyển khi bàn phím mở
let originalHeight = window.innerHeight;

window.addEventListener("resize", function() {
    if (window.innerHeight < originalHeight) {
        document.body.style.height = originalHeight + "px";
    } else {
        document.body.style.height = "100%";
    }
});